import { EditorView } from "@codemirror/view";

export function emitCursorPosition(
  onCursorPosition: (position: number) => void
) {
  return EditorView.updateListener.of(update => {
    const cursorPosition = update.state.selection.main.head;
    onCursorPosition(cursorPosition);
  });
}
